import { render, staticRenderFns } from "./FarmsTermsAndConditions.vue?vue&type=template&id=764d8423"
import script from "./FarmsTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./FarmsTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FarmsTermsAndConditions.vue?vue&type=style&index=0&id=764d8423&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports